import { TILE_COLORS } from '../boardMVC/TileColor';

export const BOARD_SETTINGS = {
  matchLength: 10,
  hints: {
    delay: 8500,
    minStacks: 3,
  },
  timing: {
    defaultStartDelay: 100,
    moveTileDelay: 150,
    moveTileDuration: 150,
    secondaryMatchStartDelay: 100,
    matchAfterRemovalDelay: 0,

    /**
     * Defines the delay (in ms) before processing the removal of a blocker. \
     * This ensures that additional blocker removal requests are captured before executing the removal logic.
     */
    blockerRemovalScheduleDelay: 30,
    blockerRemovalDuration: 1000,
    connectedBlockerRemovalDuration: 100,
    removalDuration(tiles: number): number {
      return 360 + (tiles - 1) * 60;
    },
    quickRemovalDuration(tiles: number): number {
      return 360 + (tiles - 1) * 30;
    },
  },
};

export const TRAY_SETTINGS = {
  stackSpacing: 180,
  stackBackgrounds: true,
  maxStacks: 3,
  allowRandom: true,
  animate: true,
  refills: [],
  refillColors: TILE_COLORS,
};

export const MOBILE_DRAG_OFFSET_Y = 127.5;

export const MOBILE_DRAG_OFFSET_MAX_HEIGHT_RATIO = 0.09375;